import lazySizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

export default lazySizes;
